

















































import { zip } from '@/assets/functions';
import { flagExplain, flagName, flagTitle, regExplain, Register, regName, regTitle } from "@/constants";
import { SimulatorState } from "@/simulator";
import Vue from 'vue';

export default Vue.extend({
  name: 'registers',
  props: {
    msg: String
  },
  data() {
    return {
      regName,
      regTitle,
      regExplain,

      flagName, 
      flagTitle,
      flagExplain,

      cpsrTitle: "CPSR Flags", 
      cpsrExplain: "Four bits in the Current Program Status Register which are used to decide whether a conditional instruction should execute.",

      title: null as string | null,
      description: null as string | null,

      changeSet: new Set<Register>(),
      flagChangeSet: new Set<number>()
    };
  },
  computed: {
    registers: SimulatorState.registers,
    cpsr: SimulatorState.cpsr,

    computedTitle() : string {
      return this.title ?? "Registers";
    },

    computedDescription() : string {
      return this.description ?? "A simplified view of the data currently stored in the CPU. Hover over the different sections to learn more.";
    }
  },
  methods: {
    regstr(value: number) : string {
      return `0x${value.toString(16).padStart(8, '0')} (${value})`;
    },

    hexstr(value: number) : string {
      return `0x${value.toString(16)}`
    },

    /**
     * Returns a string representing the signed representation of a 32 bit number.
     * Checks the top bit is set, if it is then returns the two's complement of the unsigned
     * value with a preceding negative '-' sign. Otherwise the value is returned as-is, because
     * the signed and unsigned representations are equal.
     */
    signedstr(value: number) : string {
      if (value >>> 31 === 1) return `-${~value + 1}`
      return `${value}`;
    },

    flagstr(value: boolean) : string {
      return value ? '1' : '0';
    },

    registerTip(reg: Register) {
      let value = this.registers[reg];
      let hexValue = this.hexstr(value);
      let signedValue = this.signedstr(value);

      this.tip(
        this.regTitle[reg],
        `\
          ${this.regExplain[reg]}
          
          Hex: ${hexValue}
          Dec:
          - Unsigned: ${value}
          - Signed:   ${signedValue}\
        `
      )
    },

    tip(title: string, description: string) {
      this.title = title;
      this.description = description
    },

    untip() {
      this.title = null;
      this.description = null;
    }
  },
  watch: {
    registers: function (newVal, oldVal) {
      let changeSet = new Set<Register>();
      zip(newVal, oldVal).forEach(([newReg, oldReg], index) => {
        if (newReg !== oldReg) changeSet.add(index);
      });

      this.changeSet = changeSet;
    },

    cpsr: function (newVal, oldVal) {
      let changeSet = new Set<number>();
      zip(newVal, oldVal).forEach(([newFlag, oldFlag], index) => {
        if (newFlag !== oldFlag) changeSet.add(index);
      });

      this.$set(this, 'flagChangeSet', changeSet);
    }
  }
})
